// 游学管理
export default [
  {
    path: "/studyTour",
    name: "studyTourManage",
    meta: { title: "游学管理" },
    component: () => import("../views/studyTour/index"),
    children: [
      {
        path: "/studyTour/studyTourList",
        meta: { title: "游学列表", isMenu: true },
        component: () => import("../views/studyTour/studyTourList"),
      },
      {
        path: "/studyTour/detail/applyStudyTour",
        meta: { title: "新增游学", isMenu: true },
        component: () => import("../views/studyTour/detail/applyStudyTour"),
      },
      {
        path: "/studyTour/detail/buyerList",
        meta: { title: "已购用户", isMenu: true },
        component: () => import("../views/studyTour/detail/buyerList"),
      },
      {
        path: "/studyTour/categoryList",
        meta: { title: "游学分类", isMenu: true },
        component: () => import("../views/studyTour/categoryList"),
      },
    ],
  },
]
